<template>
	<Layout :pageTitle="'Preguntas frecuentes'">
		<template #cta>
			<router-link tag="a" to="/faqs/create" class="btn btn-success">Crear pregunta</router-link>
		</template>

		<div class="main-container container-fluid">
			<div class="card mt-2">
				<div class="card-body">
					<draggable
						tag="table"
						class="table table-clickeable"
						v-model="list"
						handle=".handle"
						ghost-class="ghost"
						@change="sorted($event, list, 'faqSort')"
					>
						<tr class="table-head" slot="header">
							<td width="36"></td>
							<td>Pregunta</td>
						</tr>

						<router-link tag="tr" :to="`/faqs/${item.id}`" v-for="item of list" :key="item.id">
							<td>
								<div class="handle">
									<i class="icon icon-arrow-combo text-secondary"></i>
								</div>
							</td>
							<td>
								<div class="d-flex align-items-center">
									{{ item.question }}
								</div>
							</td>
						</router-link>
					</draggable>

					<div class="alert alert-info text-center" v-if="!loading && list.length == 0">
						No se han encontrado preguntas
					</div>

					<Loader :show="loading" type="inline" />

					<Pagination :pageData="pagination" @pageChange="pageChange" />
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "Faq",
	data() {
		return {
			list: [],
			loading: true
		}
	},
	beforeMount() {
		this.filters = this.getValidUrlParams()
		this.load()
	},
	methods: {
		load() {
			this.$apollo
				.query({
					query: gql`
						query($take: Int, $skip: Int) {
							faqs(take: $take, skip: $skip) {
								data {
									id
									question
									order
								}
								pageInfo {
									totalItems
								}
							}
						}
					`,
					variables: {
						take: this.pagination.length,
						skip: this.pagination.skip
					},
					fetchPolicy: "network-only"
				})
				.then((data) => {
					this.list = data.data.faqs.data
					this.pagination.pageInfo = data.data.faqs.pageInfo
					this.loading = false
				})
		}
	}
}
</script>

<style></style>
